import { applicationChangeProfileConstants } from './constants';
import axios from '../helpers/axios';
import swal from 'sweetalert';

const getErrorMessage = (error, fallback = 'Ошибка запроса') => (
  error?.response?.data?.message ||
  error?.response?.data?.error ||
  error?.message ||
  fallback
);

// Legacy action. Старый кабинет продолжает вызывать этот метод,
// но BACKEND теперь применяет personal/contact сразу и создаёт audit-запись.
export const createApplicationChangeProfile = (payload) => {
  return async (dispatch) => {
    dispatch({
      type: applicationChangeProfileConstants.CREATE_APPLICATION_CHANGE_PROFILE_REQUEST
    });

    try {
      const res = await axios.post('/applicationChangeProfile/create', {
        ...payload,
        source: 'legacy',
      });

      dispatch({
        type: applicationChangeProfileConstants.CREATE_APPLICATION_CHANGE_PROFILE_SUCCESS,
        payload: res.data,
      });

      await dispatch(getApplicationsChangeProfileByUser());

      swal({
        title: 'Данные сохранены',
        text: res.data?.message || 'Изменение записано в историю',
        icon: 'success',
      });

      return {
        ok: true,
        ...res.data,
      };
    } catch (error) {
      const message = getErrorMessage(error, 'Не удалось изменить данные');

      dispatch({
        type: applicationChangeProfileConstants.CREATE_APPLICATION_CHANGE_PROFILE_FAILURE,
        payload: { message },
      });

      swal({
        title: 'Не удалось сохранить',
        text: message,
        icon: 'warning',
      });

      return {
        ok: false,
        message,
      };
    }
  };
};

export const getApplicationsChangeProfileByUser = () => {
  return async (dispatch) => {
    dispatch({
      type: applicationChangeProfileConstants.GET_APPLICATION_CHANGE_PROFILE_BY_USER_REQUEST
    });

    try {
      const res = await axios.get('/applicationChangeProfile/getByUser');

      dispatch({
        type: applicationChangeProfileConstants.GET_APPLICATION_CHANGE_PROFILE_BY_USER_SUCCESS,
        payload: res.data,
      });

      return res.data?.applicationsChangeProfile || [];
    } catch (error) {
      dispatch({
        type: applicationChangeProfileConstants.GET_APPLICATION_CHANGE_PROFILE_BY_USER_FAILURE,
        payload: { message: getErrorMessage(error, 'Не удалось получить историю изменений') },
      });

      return [];
    }
  };
};

export const getApplicationsChangeProfileById = (id) => {
  return async (dispatch) => {
    dispatch({
      type: applicationChangeProfileConstants.GET_APPLICATION_CHANGE_PROFILE_BY_ID_REQUEST
    });

    try {
      const res = await axios.get(`/applicationChangeProfile/user/getById/${id}`);

      dispatch({
        type: applicationChangeProfileConstants.GET_APPLICATION_CHANGE_PROFILE_BY_ID_SUCCESS,
        payload: res.data,
      });

      return res.data?.applicationsChangeProfile || null;
    } catch (error) {
      dispatch({
        type: applicationChangeProfileConstants.GET_APPLICATION_CHANGE_PROFILE_BY_ID_FAILURE,
        payload: { message: getErrorMessage(error, 'Не удалось получить запись истории') },
      });

      return null;
    }
  };
};

export const addSamplePhotoApplicationChangeProfile = (_id, files) => {
  return async (dispatch) => {
    dispatch({
      type: applicationChangeProfileConstants.ADD_SAMPLE_PHOTO_REQUEST
    });

    try {
      const formData = new FormData();

      for (const pic of files) {
        formData.append('samplePhoto', pic);
      }

      const res = await axios.post(
        `/applicationChangeProfile/${_id}/addSamplePhoto`,
        formData
      );

      dispatch({
        type: applicationChangeProfileConstants.ADD_SAMPLE_PHOTO_SUCCESS,
        payload: res.data,
      });

      return res.data;
    } catch (error) {
      dispatch({
        type: applicationChangeProfileConstants.ADD_SAMPLE_PHOTO_FAILURE,
        payload: { message: getErrorMessage(error, 'Не удалось загрузить фото') },
      });

      return null;
    }
  };
};

// Новые имена для нового UI. Старые экспорты оставлены для legacy-кода.
export const getProfileChangeHistoryByUser = getApplicationsChangeProfileByUser;
export const getProfileChangeHistoryById = getApplicationsChangeProfileById;
